// Swatch initialization function
function initializeSwatches() {
  const productImageContainers = document.querySelectorAll('.card--media');

  if (!productImageContainers || productImageContainers.length === 0) {
    console.error('Product image containers not found.');
    return;
  }

  const baseImageUrl = '//sixdthelabel.myshopify.com/cdn/shop/';

  productImageContainers.forEach((container) => {
    container.addEventListener('click', function (event) {
      const swatchContainer = container.querySelector('.card__media .media');
      const selectedButton = container.querySelector('.circle-swatch__selected');

      const swatch = event.target.closest('.circle-swatch__unselected');
     if (swatch) {
  const variantImage = swatch.getAttribute('data-variant-image');
  const newMaterialDesc = swatch.getAttribute('data-metafield');

  updateProductImage(swatchContainer, variantImage);

  if (selectedButton) {
    // Grab the selected swatch's current values before overwriting
    const prevMetafield = selectedButton.getAttribute('data-metafield');
    const prevVariantImage = selectedButton.getAttribute('data-variant-image');

    // Transfer values to the outgoing swatch (now becoming unselected)
    swatch.setAttribute('data-metafield', prevMetafield);
    swatch.setAttribute('data-variant-image', prevVariantImage);

    // Swap classes
    selectedButton.classList.remove('circle-swatch__selected');
    selectedButton.classList.add('circle-swatch__unselected');
  }

  // Set the new selected swatch's values
  swatch.setAttribute('data-metafield', newMaterialDesc);
  swatch.setAttribute('data-variant-image', variantImage);

  swatch.classList.remove('circle-swatch__unselected');
  swatch.classList.add('circle-swatch__selected');

  const materialDesc = container.querySelector('.material_desc');
  if (materialDesc) {
    materialDesc.textContent = newMaterialDesc;
  }
}
    });
  });

  function updateProductImage(container, imageUrl) {
    const fullImageUrl = baseImageUrl + imageUrl;
    const imgTag = `<img src="${fullImageUrl}" alt="{{ product.title }}">`;

    const img = new Image();
    img.onload = function () {
      container.innerHTML = imgTag;
    };
    img.onerror = function () {
      console.error('Error loading image:', fullImageUrl);
    };
    img.src = fullImageUrl;
  }
}

// Initial swatch initialization
document.addEventListener('DOMContentLoaded', function () {
  initializeSwatches();
});
